module.exports = __webpack_public_path__ + "img/rocchio-tfidf.fc852428.png";